import {FC} from 'react'
import 'app/validator'
import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'
import OrderRoutes from './OrderRoutes'

type Props = {}

const OrderApp: FC<Props> = () => {
  return <></>
}

const mount = () => {}

export default OrderApp

export {OrderRoutes}
